import React from 'react';
import PropTypes from 'prop-types';
import {
  Table, TableBody, TableCell, TableHeader, TableRow
} from '@thd-olt-component-react/core-ui';
import { getRows } from '../helpers';
import './specifications.scss';

export const AttributeContent = ({ attributeGroupList, oneColumn }) => {
  const rowSize = oneColumn ? 1 : 2;
  const rows = getRows({ attributeGroupList, rowSize });
  const { specTitle } = attributeGroupList;
  const shouldRenderBlankCells = (row) => row && row.length % 2 === 1 && !oneColumn;
  return (
    <Table name={specTitle}>
      <TableBody>
        {rows.map((row, index) => (
          <TableRow key={`${specTitle}-row-${index + 1}`} className="specifications__row">
            {row.map((attr, i) => (
              <React.Fragment key={`${specTitle}-pair-${i}`}>
                <TableHeader
                  className="specifications__cell specifications__cell__label"
                  key={`${specTitle}-${attr.specName}-${i}`}
                >
                  {attr.specName}
                </TableHeader>
                <TableCell
                  className="specifications__cell"
                  key={`${specTitle}-${attr.specValue}-${i}`}
                >
                  {attr.specValue}
                </TableCell>
              </React.Fragment>
            ))}
            {shouldRenderBlankCells(row) && (
              <>
                <TableCell
                  className="specifications__cell specifications__cell__empty specifications__cell__label"
                  key={`${specTitle}-blank-header-${index}`}
                />
                <TableCell
                  className="specifications__cell specifications__cell__empty"
                  key={`${specTitle}-blank-data-${index}`}
                />
              </>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

AttributeContent.displayName = 'AttributeContent';

AttributeContent.propTypes = {
  attributeGroupList: PropTypes.shape({
    specifications: PropTypes.arrayOf(PropTypes.shape({
      specValue: PropTypes.string,
      specName: PropTypes.string,
    })),
    specTitle: PropTypes.string,
  }),
  oneColumn: PropTypes.bool
};

AttributeContent.defaultProps = {
  attributeGroupList: null,
  oneColumn: false,
};
